import { AxiosError } from "axios";
import { useQuery, UseQueryResult } from "react-query";
import { getMergedProducts } from "../api";
import { Product } from "./types";

type Params = {
  enabled?: boolean;
};

export const useProducts = ({ enabled = true }: Params = {}): UseQueryResult<
  Product[],
  AxiosError
> =>
  useQuery<Product[], AxiosError>("products", getMergedProducts, { enabled });
